// redux/slices/appBannerSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visible: true,
};

const appBannerSlice = createSlice({
  name: 'appBanner',
  initialState,
  reducers: {
    hideBanner: (state) => {
      state.visible = false;
      sessionStorage.setItem('appBannerHidden', 'true');
    },
    resetBanner: (state) => {
      state.visible = true;
      sessionStorage.removeItem('appBannerHidden');
    },
    initializeBanner: (state) => {
      state.visible = sessionStorage.getItem('appBannerHidden') !== 'true';
    },
  },
});

export const { hideBanner, resetBanner, initializeBanner } = appBannerSlice.actions;
export default appBannerSlice.reducer;
